// Animation states that map to spritesheet files and 3D model animations
export const ANIMATION_STATES = {
  idle: 'idle',
  walk: 'walk',
  eat: 'eat',
  pet: 'pet',
  dance: 'dance',
  trick: 'trick',
  hug: 'hug',
  bonk: 'bonk',
  sleep: 'sleep',
  spawn: 'spawn',
  despawn: 'despawn'
}

// Labels for the upload panel UI
export const ANIMATION_STATE_LABELS = {
  idle_a: 'Idle A',
  idle_b: 'Idle B',
  idle_c: 'Idle C',
  walk: 'Walk',
  run: 'Run',
  eat: 'Eat (!feed / !feast)',
  pet: 'Pet (!pet)',
  dance: 'Dance (!dance)',
  trick: 'Trick (!trick)',
  hug: 'Hug (!hug)',
  bonk: 'Bonk (!bonk)',
  sleep: 'Sleep',
  spawn: 'Spawn',
  despawn: 'Despawn'
}

// Default empty animation map matching all states
export const EMPTY_ANIMATION_MAP = {
  idle_a: '',
  idle_b: '',
  idle_c: '',
  walk: '',
  run: '',
  eat: '',
  pet: '',
  dance: '',
  trick: '',
  hug: '',
  bonk: '',
  sleep: '',
  spawn: '',
  despawn: ''
}